export function clothing(clothingData) {
  return {
    type: 'CLOTHING',
    clothingData
  }
}